import styled from 'styled-components';

export const PageWrapper = styled.div`
    width: 100%;
    min-height: 100vh;
    background: var(--black-color);
    color: rgba(255, 255, 255, 0.85);
`;

export const TopBar = styled.div`
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 24px;
    background: rgba(44, 44, 44, 0.95);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(255, 153, 0, 0.2);

    @media (max-width: 600px) {
        padding: 10px 16px;
    }
`;

export const LogoImg = styled.img`
    height: 38px;
    width: auto;
    cursor: pointer;

    @media (max-width: 600px) {
        height: 30px;
    }
`;

export const BackButton = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.8);
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: rgba(255, 153, 0, 0.1);
        border-color: rgba(255, 153, 0, 0.45);
        color: var(--white-color);
    }

    &:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 2px;
    }

    @media (max-width: 600px) {
        font-size: 0.8rem;
        padding: 7px 12px;
    }
`;

export const DocContainer = styled.div`
    max-width: 820px;
    margin: 0 auto;
    padding: 50px 24px 80px;

    > h1 {
        color: var(--white-color);
        font-size: 2.1rem;
        font-weight: 800;
        line-height: 1.2;
        margin: 0 0 8px 0;
        text-wrap: balance;
    }

    .last-update {
        color: rgba(255, 255, 255, 0.5);
        font-size: 0.9rem;
        margin: 0 0 36px 0;
    }

    @media (max-width: 600px) {
        padding: 32px 18px 60px;

        > h1 {
            font-size: 1.6rem;
        }
    }
`;

// Estilização do conteúdo Markdown convertido em HTML
export const DocBody = styled.div`
    font-size: 1rem;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.82);

    h2 {
        color: var(--white-color);
        font-size: 1.4rem;
        font-weight: 700;
        margin: 38px 0 14px 0;
        padding-top: 10px;
        border-top: 1px solid rgba(255, 255, 255, 0.08);
        text-wrap: balance;
    }

    h3 {
        color: rgba(255, 255, 255, 0.95);
        font-size: 1.1rem;
        font-weight: 700;
        margin: 26px 0 10px 0;
    }

    p {
        margin: 0 0 16px 0;
    }

    ul, ol {
        margin: 0 0 18px 0;
        padding-left: 24px;
    }

    li {
        margin: 6px 0;
    }

    strong {
        color: var(--white-color);
        font-weight: 700;
    }

    a {
        color: var(--primary-color);
        text-decoration: underline;
        word-break: break-word;

        &:hover {
            color: rgb(255, 184, 79);
        }
    }

    /* Tabelas (finalidades x bases legais, compartilhamento, etc.) */
    table {
        width: 100%;
        border-collapse: collapse;
        margin: 0 0 24px 0;
        font-size: 0.92rem;
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }

    th, td {
        border: 1px solid rgba(255, 255, 255, 0.12);
        padding: 10px 12px;
        text-align: left;
        white-space: normal;
    }

    th {
        background: rgba(255, 153, 0, 0.1);
        color: var(--white-color);
        font-weight: 700;
    }

    tr:nth-child(even) td {
        background: rgba(255, 255, 255, 0.02);
    }

    hr {
        border: none;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        margin: 28px 0;
    }

    blockquote {
        border-left: 3px solid var(--primary-color);
        background: rgba(255, 153, 0, 0.06);
        margin: 0 0 18px 0;
        padding: 12px 18px;
        border-radius: 0 8px 8px 0;
        color: rgba(255, 255, 255, 0.75);
    }

    code {
        background: rgba(0, 0, 0, 0.35);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 4px;
        padding: 1px 6px;
        font-size: 0.9em;
    }
`;

export const FooterNote = styled.div`
    margin-top: 50px;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.4);
`;
